import Home from "./pages/Home";
import Login from "./pages/Login";
import Launch from "./pages/Launch";
import Verify from "./pages/Verify";

 
export default function App() {

  const userData = localStorage.getItem("_tm_userData");
  const isLaunchVal = localStorage.getItem("_tm_isLaunch");
  const isHomeVal = localStorage.getItem("_tm_isHome");

  const isLogin =
    userData && userData !== "_lgt";

  const isLaunch =
    isLaunchVal !== "" && isLaunchVal !== "Y"
      ? false
      : true;

  const isHome =
    isHomeVal !== "" && isHomeVal === "N"
      ? false
      : true;

  return (
    <div className="App">
      {!isLogin ? (
        <Login />
      ) : isLogin && !isHome ? (
        <Verify />
      ) : isLaunch ? (
        <Launch />
      ) : (
        <Home />
      )}
    </div>
  );
}